var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content_box"},[_c('el-button',{staticClass:"handleOpen",attrs:{"type":"primary","size":"mini"},on:{"click":_vm.handleOpen}},[_vm._v("新窗口预览")]),_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.iframe,"width":"100%","height":"85%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }